import React, { useEffect, useRef, useState } from "react";
import "./CareSteps.css";
const steps = [
  {
    number: "01",
    title: "Book An Appointment",
    description:
      "Pick a convenient slot via our online scheduler or call our front desk. Share your symptoms (heartburn, abdominal pain, bowel changes) and any prior reports so we can prepare the right evaluation.",
  },
  {
    number: "02",
    title: "Consult Our Experts",
    description:
      "Meet Dr. Shruti Sagar for a thorough consultation. We review your history, perform a focused exam, and recommend the right tests—endoscopy/colonoscopy, ultrasound, FibroScan, or lab work—only when truly needed.",
  },
  {
    number: "03",
    title: "Receive Care",
    description:
      "Based on your diagnosis, we craft a tailored plan: medications, diet guidance (e.g., low-FODMAP/anti-reflux), therapeutic endoscopy, or day-care procedures. Our team explains every step and ensures a comfortable experience.",
  },
  {
    number: "04",
    title: "Follow–Up",
    description:
      "We track your progress, fine-tune treatment, and answer questions on diet, lifestyle, and prevention. Secure reports are shared digitally, with easy access to refills, reminders, and quick re-visits if symptoms change.",
  },
];

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Krisara Gastro and Liver Clinic",
    url: "https://krisaragastro.com/",
    logo: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    image: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    telephone: "+91 7569541532",
    email: "gastro@krisara.com",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally",
      addressLocality: "Hyderabad",
      addressRegion: "Telangana",
      postalCode: "500014",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.facebook.com/krisaragastro",
      "https://www.instagram.com/krisaragastro",
    ],
  };

const CareSteps = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setIsVisible(true);
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);
  return (
    <section
      ref={sectionRef}
      className={`care-section ${isVisible ? "animate" : ""}`}>
      <div className="care-header">
        <h2 className="fade-up" style={{ transitionDelay: "0.2s" }}>
          Trusted Gastro Care With A Focus On Your Well-Being
        </h2>
        <p className="fade-up" style={{ transitionDelay: "0.4s" }}>
          At Krisara Gastro & Liver Clinic, we've streamlined the care journey
          so treatment is fast, clear, and comfortable—from first call to full
          recovery.
        </p>
      </div>
      <div className="care-grid">
        {steps.map((step, index) => (
          <div
            key={index}
            className={`care-card fade-up ${
              index   == 6 ? "bg-light" : "bg-alt"
            }`}
            style={{ transitionDelay: `${0.6 + index * 0.2}s` }}>
            <div className="step-content">
              <div className="step-number">{step.number}</div>
              <div className="step-info">
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
export default CareSteps;